import { throttle } from 'lodash';
import { useCallback, useLayoutEffect, useState } from 'react';

export default function useWindowSize() {
  const [size, setSize] = useState<[width: number, height: number]>([0, 0]);

  const updateSizeThrottled = useCallback(throttle(updateSize, 200), []);

  function updateSize() {
    setSize([window.innerWidth, window.innerHeight]);
  }

  useLayoutEffect(() => {
    window.addEventListener('resize', updateSizeThrottled);
    updateSizeThrottled();
    return () => window.removeEventListener('resize', updateSizeThrottled);
  }, [updateSizeThrottled]);

  return size;
}
